import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Menu } from '@grapecity/wijmo.input';
import { CellRange, CellType, FlexGrid, MergeManager, GridPanel } from '@grapecity/wijmo.grid';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { TabPanel } from '@grapecity/wijmo.nav';

import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';

import { KYMW1500Model } from './kymw1500.model';
import { KYMW1501Component } from '../kymw1501/kymw1501.component';
import { KYMW1502Component } from '../kymw1502/kymw1502.component';
import { KYMW1503Component } from '../kymw1503/kymw1503.component';
import { KYMW1504Component } from '../kymw1504/kymw1504.component';
import { KYMW1505Component } from '../kymw1505/kymw1505.component';
import { KYMW1506Component } from '../kymw1506/kymw1506.component';
import { KYMW1507Component } from '../kymw1507/kymw1507.component';
import { KYMW1507InputModel } from '../kymw1507/vo/kymw1507-input.model';
import { KYMW1508Component } from '../kymw1508/kymw1508.component';
import { KYMW1508InputModel } from '../kymw1508/vo/kymw1508-input.model';
import { KYMW1509Component } from '../kymw1509/kymw1509.component';
import { KYMW1510Component } from '../kymw1510/kymw1510.component';
import { KYMW1510InputModel } from '../kymw1510/vo/kymw1510-input.model';

import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { GetMarkGroupListService } from './api-services/get-mark-group-list.service';
import { GetSupplyPromoteMarkDivListService } from './api-services/get-supply-promote-mark-div-list.service';
import { GetMarkFileService } from './api-services/get-mark-file.service';
import { UpdateMarkFileEnabledEventService } from './api-services/update-mark-file-enabled.service';
import { DeleteMarkFileService } from './api-services/delete-mark-file.service';
import { GetMarkImageDownloadService } from './api-services/get-mark-image-download.service';
import { UpdateMarkFilePeriodService } from './api-services/update-mark-file-period.service';
import { RegistMarkFilePeriodService } from './api-services/regist-mark-file-period.service';
import { GetCwsIconDataService } from './api-services/get-cws-icon-data.service';
import { DeleteCwsIconFileDataService } from './api-services/delete-cws-icon-file-data.service';
import { GetMarkConvInfoService } from './api-services/get-mark-conv-info.service';
import { GetCwsIconConvInfoService } from './api-services/get-cws-icon-conv-info.service';
import { UpdateCwsMarkConvService } from './api-services/update-cws-mark-conv.service';
import { UpdateCwsIconConvService } from './api-services/update-cws-icon-conv.service';

import { GetMarkFileRequestModel } from '../kymw1501/vo/get-mark-file-request.model';
import { MarkFileRequestModel } from '../kymw1502/vo/mark-file-request.model';
import { Subject } from 'rxjs';


/**
 * 関連タブの関連一覧のセルの結合を管理するクラス
 *
 * @class RestrictedMergeManager
 */
class RestrictedMergeManager extends MergeManager {
  getMergedRange(p: GridPanel, r: number, c: number, clip: boolean = true) {
    //
    // create basic cell range
    let rng = null;
    // ヘッダー行、関連対象マーク/アイコン、マーク/アイコン画像の列はスキップ
    if (p.cellType !== CellType.Cell || c > 4) {
      return rng;
    }
    //
    // start with single cell
    rng = new CellRange(r, c);
    let pcol = c > 0 ? c - 1 : c;
    //
    // get reference values to use for merging
    // アイコン/マークコード
    let val1 = p.getCellData(r, 1, false);
    // 連番
    let val2 = p.getCellData(r, 2, false);
    //
    // expand up
    while (rng.row > 0 &&
      p.getCellData(rng.row - 1, 1, false) == val1 &&
      p.getCellData(rng.row - 1, 2, false) == val2) {
      rng.row--;
    }
    //
    // expand down
    while (rng.row2 < p.rows.length - 1 &&
      p.getCellData(rng.row2 + 1, 1, false) == val1 &&
      p.getCellData(rng.row2 + 1, 2, false) == val2) {
      rng.row2++;
    }
    //
    // don't bother with single-cell ranges
    if (rng.isSingleCell) {
      rng = null;
    }
    //
    // done
    return rng;
  }
}

/**
 * マーク管理画面を管理するクラス
 *
 * @export KYMW1500Component
 * @class KYMW1500Component
 */
@Component({
  selector: 'app-kymw1500',
  templateUrl: 'kymw1500.component.html',
  styleUrls: ['kymw1500.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1500Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('dtg_MarkList', { static: true }) dtg_MarkList: FlexGrid;
  @ViewChild('dtg_CwsIconDataList', { static: true }) dtg_CwsIconDataList: FlexGrid;
  @ViewChild('dtg_MarkConvInfoList', { static: true }) dtg_MarkConvInfoList: FlexGrid;
  @ViewChild('dtg_CwsIconConvInfoList', { static: true }) dtg_CwsIconConvInfoList: FlexGrid;
  @ViewChild('dtg_MarkListForRelation', { static: true }) dtg_MarkListForRelation: FlexGrid;
  @ViewChild('dtg_CwsIconDataListForRelation', { static: true }) dtg_CwsIconDataListForRelation: FlexGrid;
  @ViewChild('flr_CwsIconDataList', { static: true }) flr_CwsIconDataList: FlexGridFilter;
  @ViewChild('flr_MarkConvInfoList', { static: true }) flr_MarkConvInfoList: FlexGridFilter;
  @ViewChild('flr_CwsIconConvInfoList', { static: true }) flr_CwsIconConvInfoList: FlexGridFilter;
  @ViewChild('flr_MarkListForRelation', { static: true }) flr_MarkListForRelation: FlexGridFilter;
  @ViewChild('flr_CwsIconDataListForRelation', { static: true }) flr_CwsIconDataListForRelation: FlexGridFilter;
  @ViewChild('tab_Mark', { static: true }) tab_Mark: TabPanel;
  @ViewChild('a_Mark', { static: true }) a_Mark: ElementRef;
  @ViewChild('a_CwsIcon', { static: true }) a_CwsIcon: ElementRef;
  @ViewChild('a_Relation', { static: true }) a_Relation: ElementRef;

  /** モデル   */
  public model: KYMW1500Model = new KYMW1500Model();

  /** 編集済みかをチェックするカウンタ */
  public editFlag: boolean = <boolean>false;

  /** 親画面への連携用 */
  setKYMW1500Parameter: Function;

  // コンテキストメニュー
  private dtgMarkListCm: Menu;
  private dtgCwsIconDataListCm: Menu;
  private dtgMarkConvInfoListCm: Menu;
  private dtgCwsIconConvInfoListCm: Menu;

  /**
   *Creates an instance of KYMW1500Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private fileDownloadConfirmService: FileDownloadConfirmService,
    private getMarkGroupListService: GetMarkGroupListService,
    private getSupplyPromoteMarkDivListService: GetSupplyPromoteMarkDivListService,
    private getMarkFileService: GetMarkFileService,
    private updateMarkFileEnabledEventService: UpdateMarkFileEnabledEventService,
    private deleteMarkFileService: DeleteMarkFileService,
    private getMarkImageDownloadService: GetMarkImageDownloadService,
    private updateMarkFilePeriodService: UpdateMarkFilePeriodService,
    private registMarkFilePeriodService: RegistMarkFilePeriodService,
    private getCwsIconDataService: GetCwsIconDataService,
    private deleteCwsIconFileDataService: DeleteCwsIconFileDataService,
    private getMarkConvInfoService: GetMarkConvInfoService,
    private getCwsIconConvInfoService: GetCwsIconConvInfoService,
    private updateCwsMarkConvService: UpdateCwsMarkConvService,
    private updateCwsIconConvService: UpdateCwsIconConvService,
    private changeDetector: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1500Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1500';
    // ヘッダー行の高さ
    this.dtg_MarkList.columnHeaders.rows[0].height = 52;
    this.dtg_CwsIconDataList.columnHeaders.rows[0].height = 52;
    this.dtg_MarkConvInfoList.columnHeaders.rows[0].height = 52;
    this.dtg_CwsIconConvInfoList.columnHeaders.rows[0].height = 52;
    this.dtg_MarkListForRelation.columnHeaders.rows[0].height = 52;
    this.dtg_CwsIconDataListForRelation.columnHeaders.rows[0].height = 52;

    // コンテキストメニュー設定
    this.setDtgMarkListCm();
    this.setDtgCwsIconDataListCm();
    this.setDtgMarkConvInfoListCm();
    this.setDtgCwsIconConvInfoListCm();

    // 画面初期設定
    this.initKYMW1500MarkTab();

    this.dtg_MarkList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_MarkList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dtg_MarkList);
    });

    this.dtg_CwsIconDataList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_CwsIconDataList.select(-1, -1);

      // データグリッド行の背景色設定処理
      this.setColorPattern(this.dtg_CwsIconDataList);
    });

    this.dtg_MarkConvInfoList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_MarkConvInfoList.select(-1, -1);
    });
    // セルの結合
    this.dtg_MarkConvInfoList.mergeManager = new RestrictedMergeManager();

    this.dtg_CwsIconConvInfoList.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_CwsIconConvInfoList.select(-1, -1);
    });
    // セルの結合
    this.dtg_CwsIconConvInfoList.mergeManager = new RestrictedMergeManager();

    this.dtg_MarkListForRelation.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_MarkListForRelation.select(-1, -1);
    });
    this.dtg_MarkListForRelation.hostElement.addEventListener('click', e => {
      const ht = this.dtg_MarkListForRelation.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_MarkListForRelation.getCellData(ht.row, ht.col, false);
        this.dtg_MarkListForRelation.setCellData(ht.row, ht.col, val ? false : true);
      }
    });

    this.dtg_CwsIconDataListForRelation.itemsSourceChanged.addHandler(() => {
      // データグリッド行の選択解除
      this.dtg_CwsIconDataListForRelation.select(-1, -1);
    });
    this.dtg_CwsIconDataListForRelation.hostElement.addEventListener('click', e => {
      const ht = this.dtg_CwsIconDataListForRelation.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_CwsIconDataListForRelation.getCellData(ht.row, ht.col, false);
        this.dtg_CwsIconDataListForRelation.setCellData(ht.row, ht.col, val ? false : true);
      }
    });

    // マークタブ遷移時の処理
    this.a_Mark.nativeElement.addEventListener('click', (e: MouseEvent) => {
      // マークタブの初期表示
      this.initKYMW1500MarkTab();
    });

    // アイコンタブ遷移時の処理
    this.a_CwsIcon.nativeElement.addEventListener('click', (e: MouseEvent) => {
      // アイコンタブの初期表示
      this.initKYMW1500CwsIconTab();
    });

    // 関連タブ遷移時の処理
    this.a_Relation.nativeElement.addEventListener('click', (e: MouseEvent) => {
      // 関連タブの初期表示
      this.initKYMW1500RelationTab();
    });

    this.changeDetector.detectChanges();

    // 権限取得
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {    // 「2：フルコントロール」以外の場合
      this.model.registMarkBtnDisabled = true;
      this.model.registMarkFileBtnDisabled = true;
      this.model.registCwsIconDataBtnDisabled = true;
      this.model.updateMarkOrCwsIconBtnDisabled = true;
    }
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW1500Component
   */
  public ngAfterViewInit(): void {
    if (this.flr_CwsIconDataList) {
      this.flr_CwsIconDataList.defaultFilterType = FilterType.Both;
      this.flr_CwsIconDataList.showSortButtons = true;
      this.flr_CwsIconDataList.filterColumns = ['iconGroupName', 'iconCode', 'iconName', 'outputDivStr'];
      this.flr_CwsIconDataList.onFilterApplied = (() => {
        this.setColorPattern(this.dtg_CwsIconDataList);
      });
    }
    if (this.flr_MarkConvInfoList) {
      this.flr_MarkConvInfoList.defaultFilterType = FilterType.Both;
      this.flr_MarkConvInfoList.showSortButtons = true;
      this.flr_MarkConvInfoList.filterColumns = ['iconGroupName', 'iconName'];
      this.flr_MarkConvInfoList.onFilterApplied = (() => {
        // 行の背景色を交互にする処理
        let rowNo = 0;
        for (const row of this.dtg_MarkConvInfoList.rows) {
          if (row.index === 0) {
            row.cssClass = "backgroud-color-white";
          }
          else {
            // 結合されている行かを判定
            if (this.dtg_MarkConvInfoList.rows[row.index - 1].dataItem.iconCode !== row.dataItem.iconCode ||
              this.dtg_MarkConvInfoList.rows[row.index - 1].dataItem.iconCodeBranch !== row.dataItem.iconCodeBranch) {
              rowNo++;
            }
            if (rowNo % 2 === 0) {
              row.cssClass = "backgroud-color-white";
            } else {
              row.cssClass = "backgroud-color-gray";
            }
          }
        }
      });
    }
    if (this.flr_CwsIconConvInfoList) {
      this.flr_CwsIconConvInfoList.defaultFilterType = FilterType.Both;
      this.flr_CwsIconConvInfoList.showSortButtons = true;
      this.flr_CwsIconConvInfoList.filterColumns = ['markGroupName', 'markName'];
      this.flr_CwsIconConvInfoList.onFilterApplied = (() => {
        // 行の背景色を交互にする処理
        let rowNo = 0;
        for (const row of this.dtg_CwsIconConvInfoList.rows) {
          if (row.index === 0) {
            row.cssClass = "backgroud-color-white";
          }
          else {
            // 結合されている行かを判定
            if (this.dtg_CwsIconConvInfoList.rows[row.index - 1].dataItem.markCode !== row.dataItem.markCode ||
              this.dtg_CwsIconConvInfoList.rows[row.index - 1].dataItem.markCodeBranch !== row.dataItem.markCodeBranch) {
              rowNo++;
            }
            if (rowNo % 2 === 0) {
              row.cssClass = "backgroud-color-white";
            } else {
              row.cssClass = "backgroud-color-gray";
            }
          }
        }
      });
    }
    if (this.flr_MarkListForRelation) {
      this.flr_MarkListForRelation.defaultFilterType = FilterType.Both;
      this.flr_MarkListForRelation.showSortButtons = true;
      this.flr_MarkListForRelation.filterColumns = ['markGroupName', 'markName'];
    }
    if (this.flr_CwsIconDataListForRelation) {
      this.flr_CwsIconDataListForRelation.defaultFilterType = FilterType.Both;
      this.flr_CwsIconDataListForRelation.showSortButtons = true;
      this.flr_CwsIconDataListForRelation.filterColumns = ['iconGroupName', 'iconName'];
    }
  }

  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * マークファイルリストのコンテキストメニューを追加
   */
  private setDtgMarkListCm(): void {
    this.dtgMarkListCm = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'マーク掲載順設定', cmd: 'UpdateMarkSortSetting', enabled: true },
          { caption: '適用期間の修正', cmd: 'UploadMarkFilePeriod', enabled: true },
          { caption: '別ファイルを登録', cmd: 'RegistMarkFilePeriod', enabled: true },
          { caption: '使用停止', cmd: 'UpdateMarkFileUnabled', enabled: true },
          { caption: '使用停止解除', cmd: 'UpdateMarkFileEnabled', enabled: true },
          { caption: '行削除', cmd: 'DeleteMarkFile', enabled: true },
          { caption: 'マーク画像出力', cmd: 'GetMarkImageDownload', enabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: () => {
          switch (this.dtgMarkListCm.selectedValue) {
            case 'UpdateMarkSortSetting':
              this.eventUpdateMarkSortSetting_CLICKHandler();
              break;
            case 'UploadMarkFilePeriod':
              this.eventUploadMarkFilePeriod_CLICKHandler();
              break;
            case 'RegistMarkFilePeriod':
              this.eventRegistMarkFilePeriod_CLICKHandler();
              break;
            case 'UpdateMarkFileUnabled':
              this.eventUpdateMarkFileUnabled_CLICKHandler();
              break;
            case 'UpdateMarkFileEnabled':
              this.eventUpdateMarkFileEnabled_CLICKHandler();
              break;
            case 'DeleteMarkFile':
              this.eventDeleteMarkFile_CLICKHandler();
              break;
            case 'GetMarkImageDownload':
              this.eventGetMarkImageDownload_CLICKHandler();
              break;
          }
        }
      });

    // マークファイルリスト右クリック押下時 コンテキストメニュー表示処理
    this.dtg_MarkList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.dtgMarkListCm !== undefined) {

        const ht = this.dtg_MarkList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_MarkList.select(grid, false);
          // コンテキストメニューの活性非活性制御
          this.eventDtgMarkListCm_Handler(this.dtgMarkListCm);
          // メニュー表示
          this.dtgMarkListCm.show(e);
        }
      }
    });
  }

  /**
   * マークファイルリストのコンテキストメニューの活性非活性制御
   *
   * @private
   * @param {Menu} dtgMarkListCm
   * @memberof KYMW1500Component
   */
  public eventDtgMarkListCm_Handler(contextMenu: Menu): void {

    if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
      contextMenu.itemsSource.forEach(item => {
        item.enabled = true;
        if (this.model.unabledOnly == '1') {
          if (item.caption === '使用停止') {
            item.enabled = false;
          }
        } else {
          if (item.caption === '使用停止解除') {
            item.enabled = false;
          }
          if (item.caption === '行削除') {
            item.enabled = false;
          }
        }
      });
    } else {
      contextMenu.itemsSource.forEach(item => {
        item.enabled = false;
      });
    }
  }

  /**
   * マークファイルリストのコンテキストメニュー「マーク掲載順設定」イベント
   *
   * @returns {void}
   * @memberof KYMW1500Component
   */
  public eventUpdateMarkSortSetting_CLICKHandler(): void {
    const selectedItem = this.dtg_MarkList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }

    const componentRef = this.dialogService.openModal(KYMW1505Component);
    const instance = componentRef.componentInstance as KYMW1505Component;

    instance.parent = this;
    instance.setInterfaceParam(selectedItem[0].markGroupCode);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * マークファイルリストのコンテキストメニュー「適用期間の修正」イベント
   *
   * @returns {void}
   * @memberof KYMW1500Component
   */
  public eventUploadMarkFilePeriod_CLICKHandler(): void {
    const instance: KYMW1502Component = this.createKYMW1502ComponentInstance();
    if (instance == null) {
      return;
    }

    instance.setKYMW1502Parameter = (vo: MarkFileRequestModel) => {
      this.updateMarkFilePeriodService.execute(vo, () => {
        this.updateMarkFileList(this.model.displayEndMark);
      });
    };

  }

  /** マークファイルリストのコンテキストメニュー「別ファイルを登録」イベント */
  public eventRegistMarkFilePeriod_CLICKHandler(): void {
    const instance: KYMW1502Component = this.createKYMW1502ComponentInstance();
    if (instance == null) {
      return;
    }

    instance.setKYMW1502Parameter = (vo: MarkFileRequestModel) => {
      this.registMarkFilePeriodService.execute(vo, () => {
        this.updateMarkFileList(this.model.displayEndMark);
      });
    };
  }

  /**
   * KYMW1502Componentのインスタンス作成
   *
   * @private
   * @returns {*}
   * @memberof KYMW1500Component
   */
  private createKYMW1502ComponentInstance(): KYMW1502Component {
    const selectedItem = this.dtg_MarkList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return null;
    }

    const selectedIndex: number = this.dtg_MarkList.selectedRows[0].index;

    const param: MarkFileRequestModel = new MarkFileRequestModel();
    param.MarkCode = selectedItem[0].markCode;
    param.MarkCodeBranch = selectedItem[0].markCodeBranch;
    param.StartOrderCode = selectedItem[0].startOrderCode;
    param.EndOrderCode = selectedItem[0].endOrderCode;
    param.SelectedIndex = selectedIndex;
    const componentRef = this.dialogService.openModal(KYMW1502Component);
    const instance = componentRef.componentInstance as KYMW1502Component;
    instance.parent = this;
    instance.setInterfaceParam(param);
    instance.closeFunction = () => {
      componentRef.close();
    };
    return instance;
  }

  /** マークファイルリストのコンテキストメニュー「使用停止」イベント  */
  public eventUpdateMarkFileUnabled_CLICKHandler(): void {
    this.updateMarkFileEnabled('1');
  }

  /** マークファイルリストのコンテキストメニュー「使用停止解除」イベント  */
  public eventUpdateMarkFileEnabled_CLICKHandler(): void {
    this.updateMarkFileEnabled('0');
  }

  /**
   * 使用停止の更新
   *
   * @private
   * @param {string} enabled 更新値 1:使用停止, 0:使用停止解除
   * @returns {void}
   * @memberof KYMW1500Component
   */
  private updateMarkFileEnabled(enabled: string): void {
    const selectedItem = this.dtg_MarkList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    const vo = {
      MarkCode: selectedItem[0].markCode,
      MarkCodeBranch: selectedItem[0].markCodeBranch,
      Enabled: enabled,
    };

    this.updateMarkFileEnabledEventService.execute(vo, (data: any) => {
      // 行の削除
      const cv = this.dtg_MarkList.editableCollectionView;
      cv.remove(cv.currentItem);
      // 件数の更新
      this.model.markFileNum = cv.items.length;
      // 選択行を解除
      this.dtg_MarkList.select(new CellRange(-1, -1), false);
    });

  }

  /** マークファイルリストのコンテキストメニュー「行削除」イベント  */
  public eventDeleteMarkFile_CLICKHandler(): void {
    const selectedItem = this.dtg_MarkList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    const vo = {
      MarkCode: selectedItem[0].markCode,
      MarkCodeBranch: selectedItem[0].markCodeBranch,
    };

    this.deleteMarkFileService.execute(vo, (data: any) => {
      // 行の削除
      const cv = this.dtg_MarkList.editableCollectionView;
      cv.remove(cv.currentItem);
      // 件数の更新
      this.model.markFileNum = cv.items.length;
      // 選択行を解除
      this.dtg_MarkList.select(new CellRange(-1, -1), false);
    });
  }

  /** マークファイルリストのコンテキストメニュー「マーク画像出力」イベント  */
  public eventGetMarkImageDownload_CLICKHandler(): void {
    const selectedItem = this.dtg_MarkList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    const vo = {
      MarkCode: selectedItem[0].markCode,
      MarkCodeBranch: selectedItem[0].markCodeBranch,
    };
    this.getMarkImageDownloadService.execute(vo, (data: any) => {
      // ファイル名の設定
      const fileName = 'MARK_' + vo.MarkCode + '_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';

      this.fileDownloadConfirmService.show(data.FileName, fileName);
    });

  }

  /**
   * アイコン情報リストのコンテキストメニューを追加
   */
  private setDtgCwsIconDataListCm(): void {
    this.dtgCwsIconDataListCm = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'アイコン掲載順設定', cmd: 'UpdateCwsIconSortSetting', enabled: true },
          { caption: 'アイコン情報編集', cmd: 'UpdateCwsIconData', enabled: true },
          { caption: '適用期間の修正', cmd: 'UploadCwsIconPeriod', enabled: true },
          { caption: '別ファイルを登録', cmd: 'RegistCwsIconDataFile', enabled: true },
          { caption: '削除', cmd: 'DeleteCwsIconFileData', enabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: () => {
          switch (this.dtgCwsIconDataListCm.selectedValue) {
            case 'UpdateCwsIconSortSetting':
              this.eventUpdateCwsIconSortSetting_CLICKHandler();
              break;
            case 'UpdateCwsIconData':
              this.eventUpdateCwsIconData_CLICKHandler();
              break;
            case 'UploadCwsIconPeriod':
              this.eventUploadCwsIconPeriod_CLICKHandler();
              break;
            case 'RegistCwsIconDataFile':
              this.eventRegistCwsIconDataFile_CLICKHandler();
              break;
            case 'DeleteCwsIconFileData':
              this.eventDeleteCwsIconFileData_CLICKHandler();
              break;
          }
        }
      });

    // アイコン情報リスト右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CwsIconDataList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.dtgCwsIconDataListCm !== undefined) {

        const ht = this.dtg_CwsIconDataList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_CwsIconDataList.select(grid, false);
          // コンテキストメニューの活性非活性制御
          this.eventListCm_Handler(this.dtgCwsIconDataListCm);
          // メニュー表示
          this.dtgCwsIconDataListCm.show(e);
        }
      }
    });
  }

  /**
   * アイコン情報/マーク変換情報/アイコン変換情報リストのコンテキストメニューの活性非活性制御
   *
   * @private
   * @param {Menu} contextMenu
   * @memberof KYMW1500Component
   */
  public eventListCm_Handler(contextMenu: Menu): void {
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {
      contextMenu.itemsSource.forEach(item => {
        item.enabled = false;
      });
    }
  }

  /** アイコン情報リストのコンテキストメニュー「アイコン掲載順設定」イベント  */
  public eventUpdateCwsIconSortSetting_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconDataList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    const componentRef = this.dialogService.openModal(KYMW1509Component);
    const instance = componentRef.componentInstance as KYMW1509Component;

    instance.parent = this;
    instance.setInterfaceParam(selectedItem[0].iconGroupCode);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /** アイコン情報リストのコンテキストメニュー「アイコン情報編集」イベント  */
  public eventUpdateCwsIconData_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconDataList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }

    const vo: KYMW1508InputModel = {
      iconCode: selectedItem[0].iconCode,
    }

    const componentRef = this.dialogService.openModal(KYMW1508Component);
    const instance = componentRef.componentInstance as KYMW1508Component;

    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
      this.updateCwsIconDataList(this.model.displayEndCwsIconData);
    };
  }

  /** アイコン情報リストのコンテキストメニュー「適用期間の修正」イベント  */
  public eventUploadCwsIconPeriod_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconDataList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }

    const vo: KYMW1510InputModel = {
      iconCode: selectedItem[0].iconCode,
      iconCodeBranch: selectedItem[0].iconCodeBranch,
    }

    const componentRef = this.dialogService.openModal(KYMW1510Component);
    const instance = componentRef.componentInstance as KYMW1510Component;

    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
      this.updateCwsIconDataList(this.model.displayEndCwsIconData);
    };
  }

  /** アイコン情報リストのコンテキストメニュー「別ファイルを登録」イベント  */
  public eventRegistCwsIconDataFile_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconDataList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }

    const vo: KYMW1507InputModel = {
      iconCode: selectedItem[0].iconCode,
      iconCodeBranch: selectedItem[0].iconCodeBranch,
    }

    const componentRef = this.dialogService.openModal(KYMW1507Component);
    const instance = componentRef.componentInstance as KYMW1507Component;

    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.closeFunction = () => {
      componentRef.close();
      this.updateCwsIconDataList(this.model.displayEndCwsIconData);
    };
  }

  /** アイコン情報リストのコンテキストメニュー「削除」イベント  */
  public eventDeleteCwsIconFileData_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconDataList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }

    // メッセージを表示する
    this.dialogService.openAlertGetMessage('Q0106', ['ECアイコン情報'],
      (closeDetail) => {
        // OKボタン押下時
        if (closeDetail === PlessAlert.Yes) {
          const vo = {
            IconCode: selectedItem[0].iconCode,
            IconCodeBranch: selectedItem[0].iconCodeBranch,
            UpdateDate: selectedItem[0].updateDate,
          };

          this.deleteCwsIconFileDataService.execute(vo, (data: any) => {
            // 行の削除
            const cv = this.dtg_CwsIconDataList.editableCollectionView;
            cv.remove(cv.currentItem);
            // 件数の更新
            this.model.cwsIconDataNum = cv.items.length;
            // 選択行を解除
            this.dtg_CwsIconDataList.select(new CellRange(-1, -1), false);
          });
        }
      },
    );
  }

  /**
   * マーク変換情報リストのコンテキストメニューを追加
   */
  private setDtgMarkConvInfoListCm(): void {
    this.dtgMarkConvInfoListCm = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'クリア', cmd: 'ClearSelectedMarkConvInfo', enabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: () => {
          switch (this.dtgMarkConvInfoListCm.selectedValue) {
            case 'ClearSelectedMarkConvInfo':
              this.eventClearSelectedMarkConvInfo_CLICKHandler();
          }
        }
      });

    // マーク変換情報リスト右クリック押下時 コンテキストメニュー表示処理
    this.dtg_MarkConvInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.dtgMarkConvInfoListCm !== undefined) {

        const ht = this.dtg_MarkConvInfoList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_MarkConvInfoList.select(grid, false);
          // コンテキストメニューの活性非活性制御
          this.eventListCm_Handler(this.dtgMarkConvInfoListCm);
          // メニュー表示
          this.dtgMarkConvInfoListCm.show(e);
        }
      }
    });
  }

  /** マーク変換情報リストのコンテキストメニュー「クリア」イベント  */
  public eventClearSelectedMarkConvInfo_CLICKHandler(): void {
    const selectedItem = this.dtg_MarkConvInfoList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    // 表示用に変換前のマーク変換情報から該当するデータの位置を探す
    const index = this.model.markConvInfoList.findIndex(item => {
      return (
        item.iconCode === selectedItem[0].iconCode &&
        item.iconCodeBranch === selectedItem[0].iconCodeBranch
      )
    });
    this.model.markConvInfoList[index].markList = [];

    // 表示用リストの再作成
    this.model.updateMarkConvInfoList();
    setTimeout(() => {
      this.dtg_MarkConvInfoList.refresh();
    }, 500);
  }

  /**
   * アイコン変換情報リストのコンテキストメニューを追加
   */
  private setDtgCwsIconConvInfoListCm(): void {
    this.dtgCwsIconConvInfoListCm = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { caption: 'クリア', cmd: 'ClearSelectedCwsIconConvInfo', enabled: true },
        ],
        command: this.getFormatMenuCommand(),
        itemClicked: () => {
          switch (this.dtgCwsIconConvInfoListCm.selectedValue) {
            case 'ClearSelectedCwsIconConvInfo':
              this.eventClearSelectedCwsIconConvInfo_CLICKHandler();
          }
        }
      });

    // アイコン変換情報リスト右クリック押下時 コンテキストメニュー表示処理
    this.dtg_CwsIconConvInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      if (this.dtgCwsIconConvInfoListCm !== undefined) {

        const ht = this.dtg_CwsIconConvInfoList.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const grid = new CellRange(ht.row, ht.col);
          this.dtg_CwsIconConvInfoList.select(grid, false);
          // コンテキストメニューの活性非活性制御
          this.eventListCm_Handler(this.dtgCwsIconConvInfoListCm);
          // メニュー表示
          this.dtgCwsIconConvInfoListCm.show(e);
        }
      }
    });
  }

  /** アイコン変換情報リストのコンテキストメニュー「クリア」イベント  */
  public eventClearSelectedCwsIconConvInfo_CLICKHandler(): void {
    const selectedItem = this.dtg_CwsIconConvInfoList.selectedItems;
    if (PlessViewUtilsSub.isEmptyArray(selectedItem)) {
      return;
    }
    // 表示用に変換前のアイコン変換情報から該当するデータの位置を探す
    const index = this.model.cwsIconConvInfoList.findIndex(item => {
      return (
        item.markCode === selectedItem[0].markCode &&
        item.markCodeBranch === selectedItem[0].markCodeBranch
      )
    });
    this.model.cwsIconConvInfoList[index].iconList = [];

    // 表示用リストの再作成
    this.model.updateCwsIconConvInfoList();
    setTimeout(() => {
      this.dtg_CwsIconConvInfoList.refresh();
    }, 500);
  }

  /**
   * マークタブの初期化
   *
   * @private
   * @memberof KYMW1500Component
   */
  private initKYMW1500MarkTab(): void {
    // 初期処理イベント発行
    this.model.displayEndMark = false;
    // マークファイル情報検索条件を設定
    this.model.markName = '';
    this.model.markFileName = '';
    this.model.markGroupCode = '';
    this.model.supplyPromoteMarkDiv = '';
    this.model.registMarkDateFrom = '';
    this.model.registMarkDateTo = '';
    this.model.fileRegistDateFrom = '';
    this.model.fileRegistDateTo = '';
    this.model.fileNonRegistOnly = '0';
    this.model.unabledOnly = '0';
    // マークグループ一覧取得、マーク区分一覧取得、マークファイル情報検索の順に実行
    this.updateMarkGroupList(() => {
      this.updateSupplyPromoteMarkDivList(() => {
        this.updateMarkFileList(this.model.displayEndMark);
      });
    });
  }

  /**
   * アイコンタブの初期化
   *
   * @private
   * @memberof KYMW1500Component
   */
  private initKYMW1500CwsIconTab(): void {
    // 初期処理イベント発行
    this.model.displayEndCwsIconData = false;
    // マークグループ一覧取得、アイコン情報一覧取得の順に実行
    this.updateMarkGroupList(() => {
      this.updateCwsIconDataList(this.model.displayEndCwsIconData);
    });
  }

  /**
   * 関連タブの初期化
   *
   * @private
   * @memberof KYMW1500Component
   */
  private initKYMW1500RelationTab(): void {
    // 初期処理イベント発行
    this.model.radioBtnValue = '1';
    // マークファイル情報検索条件を設定
    this.model.markName = '';
    this.model.markFileName = '';
    this.model.markGroupCode = '';
    this.model.supplyPromoteMarkDiv = '';
    this.model.registMarkDateFrom = '';
    this.model.registMarkDateTo = '';
    this.model.fileRegistDateFrom = '';
    this.model.fileRegistDateTo = '';
    this.model.fileNonRegistOnly = '0';
    this.model.unabledOnly = '0';

    // マークグループ一覧取得、マーク変換情報取得の順に実行
    this.updateMarkGroupList(() => {
      this.updateMarkConvInfoList();
      this.updateMarkFileList(false);
      this.updateCwsIconConvInfoList();
      this.updateCwsIconDataList(false);
      this.eventDisplayList_CLICKHandler();
    });
  }

  /**
   * マークタブの「検索」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventSearchMark_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1501Component);
    const instance = componentRef.componentInstance as KYMW1501Component;

    instance.parent = this;
    instance.setInterfaceParam(this.model.kymw1501InputVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
    instance.setKYMW1501Parameter = (vo: GetMarkFileRequestModel) => {
      this.model.markName = vo.MarkName;
      this.model.markFileName = vo.MarkFileName;
      this.model.markGroupCode = vo.MarkGroupCode;
      this.model.supplyPromoteMarkDiv = vo.SupplyPromoteMarkDiv;
      this.model.registMarkDateFrom = vo.RegistMarkDateFrom;
      this.model.registMarkDateTo = vo.RegistMarkDateTo;
      this.model.fileRegistDateFrom = vo.FileRegistDateFrom;
      this.model.fileRegistDateTo = vo.FileRegistDateTo;
      this.model.fileNonRegistOnly = (vo.FileNonRegistOnly) ? '1' : '0';
      this.model.unabledOnly = (vo.UnableOnly) ? '1' : '0';

      this.updateMarkFileList(this.model.displayEndMark);
    };
  }

  /**
   * マークタブの「マーク登録」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventRegistMark_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1503Component);
    const instance = componentRef.componentInstance as KYMW1503Component;

    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
      this.updateMarkFileList(this.model.displayEndMark);
    };
  }

  /**
   * マークタブの「マークファイル登録」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventRegistMarkFile_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1504Component);
    const instance = componentRef.componentInstance as KYMW1504Component;

    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
      this.updateMarkFileList(this.model.displayEndMark);
    };
  }

  /**
   * アイコンタブの「登録」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventRegistCwsIconData_CLICKHandler(): void {
    const componentRef = this.dialogService.openModal(KYMW1506Component);
    const instance = componentRef.componentInstance as KYMW1506Component;

    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
      this.updateCwsIconDataList(this.model.displayEndCwsIconData);
    };
  }

  /**
   * 関連タブの「＜＜」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventSet_CLICKHandler(): void {
    if (this.model.radioBtnValue === '1') {
      // 関連一覧の選択チェック
      const markConvInfoSelectedItems = this.dtg_MarkConvInfoList.selectedItems;
      if (PlessViewUtilsSub.isEmptyArray(markConvInfoSelectedItems)) {
        this.dialogService.openAlertGetMessage('E0148', ['アイコンコード']);
        return;
      }
      // マーク一覧の選択チェック
      const checkedList = this.model.markFileListForView.filter(item => { return item.check });
      if (PlessViewUtilsSub.isEmptyArray(checkedList)) {
        this.dialogService.openAlertGetMessage('E0148', ['マークコード']);
        return;
      }

      // 表示用に変換前のマーク変換情報から該当するデータの位置を探す
      const index = this.model.markConvInfoList.findIndex(item => {
        return (
          item.iconCode === markConvInfoSelectedItems[0].iconCode &&
          item.iconCodeBranch === markConvInfoSelectedItems[0].iconCodeBranch
        )
      });
      // マークリストに追加済みかどうか判定
      for (const selectedItem of this.model.markConvInfoList[index].markList) {
        for (const checkedItem of checkedList) {
          if (selectedItem.markFileName === (checkedItem.markCode + '-' + checkedItem.markCodeBranch)) {
            this.dialogService.openAlertGetMessage('E0506');
            return;
          }
        }
      }

      // チェックしたデータをマークリストに追加
      for (const checkedItem of checkedList) {
        this.model.markConvInfoList[index].markList.push(
          {
            markFileName: checkedItem.markCode + '-' + checkedItem.markCodeBranch,
            markFileUrl: checkedItem.markFileUrl
          }
        )
      }
      // 表示用リストの再作成
      this.model.updateMarkConvInfoList();
      this.dtg_MarkConvInfoList.refresh();
    } else {
      // アイコン一覧の選択チェック
      const checkedList = this.model.cwsIconDataListForView.filter(item => { return item.check });
      if (PlessViewUtilsSub.isEmptyArray(checkedList)) {
        this.dialogService.openAlertGetMessage('E0148', ['アイコンコード']);
        return;
      }
      // 関連一覧の選択チェック
      const cwsIconConvInfoSelectedItems = this.dtg_CwsIconConvInfoList.selectedItems;
      if (PlessViewUtilsSub.isEmptyArray(cwsIconConvInfoSelectedItems)) {
        this.dialogService.openAlertGetMessage('E0148', ['マークコード']);
        return;
      }

      // 表示用に変換前のアイコン変換情報から該当するデータの位置を探す
      const index = this.model.cwsIconConvInfoList.findIndex(item => {
        return (
          item.markCode === cwsIconConvInfoSelectedItems[0].markCode &&
          item.markCodeBranch === cwsIconConvInfoSelectedItems[0].markCodeBranch
        )
      });
      // マークリストに追加済みかどうか判定
      for (const selectedItem of this.model.cwsIconConvInfoList[index].iconList) {
        for (const checkedItem of checkedList) {
          if (selectedItem.iconFileName === (checkedItem.iconCode + '-' + checkedItem.iconCodeBranch)) {
            this.dialogService.openAlertGetMessage('E0587');
            return;
          }
        }
      }

      // チェックしたデータをマークリストに追加
      for (const checkedItem of checkedList) {
        this.model.cwsIconConvInfoList[index].iconList.push(
          {
            iconFileName: (checkedItem.iconCode + '-' + checkedItem.iconCodeBranch),
            iconUrl: checkedItem.iconImageUrl
          }
        )
      }
      // 表示用リストの再作成
      this.model.updateCwsIconConvInfoList();
      this.dtg_CwsIconConvInfoList.refresh();
    }
    this.editFlag = true;
  }

  /**
   * 関連タブの「更新」ボタン押下イベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventUpdateMarkOrCwsIcon_CLICKHandler(): void {
    // メッセージを表示する
    this.dialogService.openAlertGetMessage('Q0105', ['マーク変換マスタ'],
      (closeDetail) => {
        // OKボタン押下時
        if (closeDetail === PlessAlert.Yes) {
          if (this.model.radioBtnValue === '1') {
            this.updateCwsMarkConvService.execute(this.model, () => {
              this.updateMarkConvInfoList();
              this.updateCwsIconConvInfoList();
            });
          } else {
            this.updateCwsIconConvService.execute(this.model, () => {
              this.updateMarkConvInfoList();
              this.updateCwsIconConvInfoList();
            })
          }
          this.editFlag = false;
        }
      },
    );
  }

  /**
   * 「使用終了マークを表示」チェックボックスクリックイベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventDisplayEndMark_CLICKHandler(): void {
    // マークファイルリストの表示変更
    this.model.updateMarkFileList(this.model.displayEndMark, () => {
      this.dtg_MarkList.refresh();
    });
  }

  /**
   * 「使用終了アイコンを表示」チェックボックスクリックイベント処理
   *
   * @memberof KYMW1500Component
   */
  public eventDisplayEndCwsIconData_CLICKHandler(): void {
    // アイコン情報リストの表示変更
    this.model.updateCwsIconDataList(this.model.displayEndCwsIconData, () => {
      this.dtg_MarkList.refresh();
    });
  }

  private updateMarkGroupList(nextFunc?: Function): void {
    this.getMarkGroupListService.execute((data: any) => {
      this.model.updateMarkGroupList(data);
      if (this.model.markGroupList.length === 0) {
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127');
      }
      if (nextFunc) nextFunc();
    });
  }

  private updateSupplyPromoteMarkDivList(nextFunc?: Function): void {
    this.getSupplyPromoteMarkDivListService.execute((data: any) => {
      this.model.updateSupplyPromoteMarkDivList(data);
      if (this.model.supplyPromoteMarkDivList.length === 0) {
        // マーク区分が取得できませんでした
        this.dialogService.openAlertGetMessage('E0128');
      }
      if (nextFunc) nextFunc();
    });
  }

  private updateMarkFileList(displayEndMarkFlg: boolean): void {
    this.getMarkFileService.execute(this.model, () => {
      this.model.updateMarkFileList(displayEndMarkFlg, () => {
        this.dtg_MarkList.refresh();
      });
    });
  }

  private updateCwsIconDataList(displayEndCwsIconDataFlg: boolean): void {
    this.getCwsIconDataService.execute(this.model, () => {
      this.model.updateCwsIconDataList(displayEndCwsIconDataFlg, () => {
        this.dtg_CwsIconDataList.refresh();
      });
    });
  }

  private updateMarkConvInfoList(): void {
    this.getMarkConvInfoService.execute(this.model, () => {
      this.model.updateMarkConvInfoList(() => {
        this.dtg_MarkConvInfoList.refresh();
        this.dtg_MarkListForRelation.refresh();
      });
    });
  }

  private updateCwsIconConvInfoList(): void {
    this.getCwsIconConvInfoService.execute(this.model, () => {
      this.model.updateCwsIconConvInfoList();
    });
  }

  /**
   * 関連タブの表示リスト(ラジオボタン)_クリック時に呼び出されるメソッド
   *
   * @memberof KYMW1500Component
   */
  public eventDisplayList_CLICKHandler(): void {
    // 表示リストの切り替え処理
    this.setDisplayList(this.model.radioBtnValue);
  }

  /**
   * 関連タブの表示リストの切り替えを行う
   *
   * @param {string} [value=''] 表示リスト(1：アイコン、2：マーク)
   * @memberof KYMW1500Component
   */
  public setDisplayList(value = ''): void {
    // 入力パラメータの表示リストのチェック
    if (!PlessViewUtilsSub.isEmpty(value)) {
      this.model.radioBtnValue = value;
    }

    // 表示リストのチェック
    switch (this.model.radioBtnValue) {
      case '1':
        this.dtg_MarkConvInfoList.hostElement.style.display = '';
        this.dtg_CwsIconConvInfoList.hostElement.style.display = 'none';
        this.dtg_MarkListForRelation.hostElement.style.display = '';
        this.dtg_CwsIconDataListForRelation.hostElement.style.display = 'none';
        this.model.displayListName = 'マーク一覧';
        setTimeout(() => {
          this.dtg_MarkConvInfoList.refresh();
          this.dtg_MarkListForRelation.refresh();
        }, 500);
        break;
      case '2':
        this.dtg_MarkConvInfoList.hostElement.style.display = 'none';
        this.dtg_CwsIconConvInfoList.hostElement.style.display = '';
        this.dtg_MarkListForRelation.hostElement.style.display = 'none';
        this.dtg_CwsIconDataListForRelation.hostElement.style.display = '';
        this.model.displayListName = 'アイコン一覧';
        setTimeout(() => {
          this.dtg_CwsIconConvInfoList.refresh();
          this.dtg_CwsIconDataListForRelation.refresh();
        }, 500);
        break;
      default:
        break;
    }
  }

  /**
   * タブ選択変更時処理
   *
   * タブ内で最初に出てくるaに参照変数を設定して
   * タブ遷移時にフォーカスを充てている
   */
  public selectedTabChange(): void {
    const selectedIndex = this.tab_Mark.selectedIndex;
    if (selectedIndex === 0) {
      this.a_Mark.nativeElement.focus();
    } else if (selectedIndex === 1) {
      this.a_CwsIcon.nativeElement.focus();
    } else if (selectedIndex === 2) {
      this.a_Relation.nativeElement.focus();
    }
  }

  /**
   * データグリッド行の背景色設定
   *
   * @param {FlexGrid} grid 処理対象データグリッド
   * @memberof KYMW1300TargetListComponent
   */
  public setColorPattern(grid: FlexGrid): void {

    // 背景色設定
    grid.rows.forEach((row) => {
      // 使用終了しているマークのチェック(false：使用中、true：使用終了)
      if (row.dataItem.delivEndFlg) {
        if (row.isSelected) {
          row.cssClass = '';
        } else {
          row.cssClass = 'deliv-end-color';
        }
      }
    });
  }

  /**
   * 画面終了時処理
   *
   * @memberof KYMW1500Component
   */
  canDeactivate(): CanDeactivateType {
    // 編集が行われている場合、メッセージを表示
    if (this.editFlag) {
      const result = new Subject<boolean>();
      this.dialogService.openAlertGetMessage('Q0107', ['マーク変換マスタ'],
         (closeDetail: number) => {
           if (closeDetail === PlessAlert.Yes) {
             result.next(true);
           } else {
             result.next(false);
           }
      });
      return result;
    } else {
      // 自画面を終了
      return true;
    }
  }
}
